import { GroupAction } from "../../@types/contexts/groupContext/groupAction.types";
import { Store } from "../../@types/contexts/groupContext/store.types";
import actions from "./actions";

const reducer = (state: Store, action: GroupAction) => {
	switch (action.type) {
		case actions.SET_GROUP_NUMBER: {
			return {
				...state,
				group_number: action.payload.group_number
			};
		}
		default:
			throw new Error("Unexpected action: Auth Context");
	}
};

export default reducer;
